import { useContext, useCallback } from "react";
import { MCPContext } from "./MCPProvider";
import {
  Teammate,
  TeammateSelectedIntegration,
  updateTeammate as updateTeammateInState,
} from "./mcpSlice";

const useMCPContext = () => {
  const { state, dispatch } = useContext(MCPContext);

  const updateTeammate = useCallback(
    (teammate: Partial<Teammate>) => {
      dispatch(updateTeammateInState(teammate));
    },
    [dispatch]
  );

  const updateSelectedIntegrations = useCallback(
    (selectedIntegrations: TeammateSelectedIntegration[]) => {
      dispatch(updateTeammateInState({ integrations: selectedIntegrations }));
    },
    [dispatch]
  );

  const removeSelectedIntegration = useCallback(
    (integrationId: string) => {
      dispatch(
        updateTeammateInState({
          integrations: state.teammate?.integrations?.filter(
            integration => integration.id !== integrationId
          ),
        })
      );
    },
    [dispatch, state.teammate?.integrations]
  );

  const addSelectedIntegration = useCallback(
    (selectedIntegration: TeammateSelectedIntegration) => {
      dispatch(
        updateTeammateInState({
          integrations: [...(state.teammate?.integrations || []), selectedIntegration],
        })
      );
    },
    [dispatch, state.teammate?.integrations]
  );

  const updateSelectedIntegration = useCallback(
    (selectedIntegration: TeammateSelectedIntegration) => {
      dispatch(
        updateTeammateInState({
          integrations: state.teammate?.integrations?.map(integration => {
            if (integration.id === selectedIntegration.id) {
              return selectedIntegration;
            }
            return integration;
          }),
        })
      );
    },
    [dispatch, state.teammate?.integrations]
  );

  return {
    ...state,
    updateSelectedIntegrations,
    updateSelectedIntegration,
    removeSelectedIntegration,
    addSelectedIntegration,
    updateTeammate,
  };
};

export default useMCPContext;
